/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Links_Skip_To_Main_ContentInputs */

const de_commons_links_skip_to_main_content = /** @type {(inputs: Commons_Links_Skip_To_Main_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Hauptinhalt springen`)
};

/** @type {(inputs: Commons_Links_Skip_To_Main_ContentInputs) => LocalizedString} */
const en_commons_links_skip_to_main_content = de_commons_links_skip_to_main_content;

/**

* @param {Commons_Links_Skip_To_Main_ContentInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_links_skip_to_main_content = /** @type {((inputs?: Commons_Links_Skip_To_Main_ContentInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Links_Skip_To_Main_ContentInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_links_skip_to_main_content(inputs)
	return en_commons_links_skip_to_main_content(inputs)
});